import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private http: HttpClient
  ) { }

  login(apartmentNo: any, roomNo: any, countryCode: any, contactNo: any, password: any) {
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/user/login`, {
      apartmentNo: apartmentNo,
      roomNo: roomNo,
      countryCode: countryCode,
      contactNo: contactNo,
      password: password
    })
      .pipe(map(user => {
        localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
        return user;
      }));
  }

  logout() {
    localStorage.removeItem(`${environment.appName}` + 'user');
    this.router.navigate(['/login']);
  }

}
